import { triggerHostMessageHideWidget } from '../triggerHostMessage/triggerHostMessageHideWidget';
export default function hideCallingWidget(shouldHide) {
  triggerHostMessageHideWidget(shouldHide);
}